export default "__VITE_ASSET__DbFKbTJy__"